import DropDownFilter from './DropDownFilter';

export default function DropDownFacetFilters(props) {
  const fieldId = props.fieldId;
  const facets = props.facets;
  const filters = props.filters;
  const setFilter = props.setFilter;
  const removeFilter = props.removeFilter;
  const limitedOptions = props.limitedOptions;
  const sort = props.sort;
  let options =
    facets[fieldId] && facets[fieldId].length > 0
      ? facets[fieldId][0].data
      : [];

  if (limitedOptions) {
    options = options.filter(
      option => limitedOptions.indexOf(option.value) > -1,
    );
    options = options.sort(
      (a, b) =>
        limitedOptions.indexOf(a.value) - limitedOptions.indexOf(b.value),
    );
  }

  if (sort) {
    options = options.sort((a, b) =>
      a.value > b.value ? 1 : b.value > a.value ? -1 : 0,
    );
  }

  return (
    <DropDownFilter
      fieldId={fieldId}
      filters={filters}
      formHint={props.formHint}
      id={props.id}
      isLastElement={props.isLastElement}
      label={props.label}
      options={options}
      removeFilter={removeFilter}
      setFilter={setFilter}
    />
  );
}
